import '@/assets/global.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { preloadStats } from './stores/stats'




// 注册图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

async function bootstrap() {
  await preloadStats()

  const app = createApp(App)
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }

  app.use(createPinia())
  app.use(router)
  app.mount('#app')
}

bootstrap()
